export const REQUEST_WISHLIST_ITEMS="Request_Wishlist_Items";
export const SUCCESS_WISHLIST_ITEMS="Succes_Wishlist_Items";
export const FAILURE_WISHLIST_ITEMS="Failure_Wishlist_Items";

export const REQUEST_DELETEWISHLIST_ITEM="Request_DeletWifhlist_Item";
export const SUCCESS_DELETEWISHLIST_ITEM="Success_DeletWifhlist_Item";
export const FAILURE_DELETEWISHLIST_ITEM="Failure_DeletWifhlist_Item";